import {
  getStoredValue,
  setStoredValue,
} from "@WahooFitness/wahoo-offline-mfe/services/StorageService";
import { useCallback } from "react";
import useSWR from "swr";

export type valueType = string | number | boolean | null | undefined;

function useLocalStorage(key: string): { data: valueType; setValue: (value: valueType) => void } {
  const { data, mutate } = useSWR(key, getStoredValue);

  const setValue = useCallback(
    (newValue: valueType) => {
      mutate(newValue, { revalidate: false });
      setStoredValue(key, newValue);
    },
    [key, mutate]
  );

  return { data: data as valueType, setValue };
}

export default useLocalStorage;
